module.exports = __webpack_public_path__ + "img/main.1c87aa0e.png";